(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6978],{

/***/ 36714:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
}), 'East');

exports.Z = _default;

/***/ }),

/***/ 36978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12755);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_icons_material_East__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);







function Blogs(param) {
    let { relBlogs , heading  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const [blogs, setBlogs] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (relBlogs) {
            setBlogs(relBlogs);
            return;
        }
        getBlogData();
    }, [
        relBlogs
    ]);
    const getBlogData = async ()=>{
        const RES = await fetch("https://gromo.in/blog/ghost/api/v3/content/posts/?key=e5313c1e06e48b7a7a590f1b1d&include=tags,authors&limit=3").then((res)=>res.json());
        setBlogs(RES.posts);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            minHeight: "40vh",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            padding: {
                xs: "50px 30px",
                md: "60px 0"
            },
            backgroundColor: "#F4F7FF",
            borderRadius: relBlogs && blogs.length ? "15px" : "",
            margin: relBlogs && blogs.length ? "12px 0" : ""
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            sx: {
                height: "80%",
                width: {
                    xs: "100%",
                    md: "85%"
                },
                maxWidth: "1440px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        textAlign: "center",
                        fontWeight: "700",
                        sx: {
                            fontSize: {
                                xs: "24px",
                                md: "40px"
                            }
                        },
                        children: heading
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        }
                    },
                    style: {
                        justifyContent: "space-between",
                        alignContent: "center",
                        flexWrap: "wrap"
                    },
                    children: blogs && blogs.length ? blogs.map((blog, i)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            sx: {
                                maxHeight: "380px",
                                width: {
                                    xs: "100%",
                                    md: relBlogs && blogs.length ? "300px" : "352px"
                                },
                                display: "flex",
                                margin: "20px 0px",
                                flexDirection: "column",
                                cursor: "pointer",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.15)",
                                justifyContent: "space-between"
                            },
                            onClick: ()=>window.open("https://gromo.in/blog/" + blog.slug),
                            className: "blogCard",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    style: {
                                        width: "100%"
                                    },
                                    onClick: ()=>window.open("https://gromo.in/blog/" + blog.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: blog.feature_image,
                                        width: relBlogs && blogs.length ? 300 : 376,
                                        height: 190,
                                        style: {
                                            height: "190px",
                                            width: "376px",
                                            objectFit: "contain",
                                            borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        },
                                        loading: "lazy",
                                        alt: blog.custom_excerpt || "GroMo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    sx: {
                                        width: "100%",
                                        padding: {
                                            xs: "12px"
                                        },
                                        minHeight: "190px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            color: "#6C717F",
                                            children: blog.primary_tag ? blog.primary_tag.name.toUpperCase() : "Saving Account"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            fontWeight: "bold",
                                            sx: {
                                                fontSize: {
                                                    xs: "20px",
                                                    md: "24px"
                                                }
                                            },
                                            children: blog.title
                                        })
                                    ]
                                })
                            ]
                        }, blog.id);
                    }) : null
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "flex",
                            md: "none"
                        },
                        justifyContent: "center"
                    },
                    children: blogs && blogs.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        sx: {
                            maxHeight: "300px",
                            width: {
                                xs: "100%",
                                md: "300px"
                            },
                            maxWidth: {
                                xs: "300px",
                                md: ""
                            },
                            display: "flex",
                            margin: "20px 0px",
                            flexDirection: "column",
                            cursor: "pointer",
                            backgroundColor: "white",
                            borderRadius: "10px",
                            justifyContent: "space-between",
                            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.15)"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                style: {
                                    width: "100%"
                                },
                                onClick: ()=>{
                                    var ref;
                                    window.open("https://gromo.in/blog/" + ((ref = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref === void 0 ? void 0 : ref.slug));
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: (ref = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref === void 0 ? void 0 : ref.feature_image,
                                    width: 376,
                                    height: 190,
                                    style: {
                                        height: "190px",
                                        width: "376px",
                                        borderTopLeftRadius: "10px",
                                        borderTopRightRadius: "10px"
                                    },
                                    loading: "lazy",
                                    alt: ((ref1 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref1 === void 0 ? void 0 : ref1.custom_excerpt) || "GroMo"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                style: {
                                    margin: "auto",
                                    padding: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        sx: {
                                            textAlign: "left"
                                        },
                                        children: ((ref2 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref2 === void 0 ? void 0 : ref2.primary_tag) ? (ref3 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref3 === void 0 ? void 0 : ref3.primary_tag.name.toUpperCase() : "Saving Account"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        fontWeight: "bold",
                                        sx: {
                                            textAlign: "left",
                                            fontSize: {
                                                xs: "18px",
                                                md: "24px"
                                            },
                                            lineHeight: {
                                                xs: "30px",
                                                md: "36px"
                                            },
                                            fontWeight: 700
                                        },
                                        children: (ref4 = blogs[relBlogs && blogs.length ? 1 : 0]) === null || ref4 === void 0 ? void 0 : ref4.title
                                    })
                                ]
                            })
                        ]
                    }) : null
                }),
                relBlogs && blogs.length ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                    href: "https://gromo.in/blog/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        textAlign: "center",
                        padding: "8px",
                        color: "#4D71D0",
                        sx: {
                            cursor: "pointer",
                            background: "white",
                            width: "fit-content",
                            margin: "auto",
                            fontSize: "14px",
                            padding: "8px 16px",
                            boxShadow: "0px 1px 4px 0 lightgrey",
                            borderRadius: "8px"
                        },
                        children: [
                            "see more blogs ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_East__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Blogs);


/***/ }),

/***/ 12755:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);